import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { insideItems } from '../data/gallery';
import { VISUAL_IMAGE, VISUAL_IMAGE_ALT } from '../data/offer';
const imagine = ['Imagine explaining the PPE donning and doffing order with one clear step-by-step visual.', 'Walking students through a head-to-toe assessment in the right sequence.', 'Showing a correct and an incorrect sterile field side by side.', 'Solving an IV pump rate with a worked example and a sanity check.', 'And connecting every skill to real patient safety at the bedside.'];
export function VisualSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-332" data-mp="3gbik15t8i91g">
      <div className="max-w-5xl mx-auto" data-id="element-333" data-mp="3l8io5b6ix1px">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid md:grid-cols-[1fr_1.4fr] gap-8 md:gap-12 items-start" data-id="element-334" data-mp="3l9a9zuabjl30">
          <div data-id="element-335" data-mp="eq0sujzmxu36">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-5 text-[#0B2545] uppercase" data-id="element-336" data-mp="eton5lcwmkiy">
              See What You&apos;re Teaching
            </h2>
            <p className="text-xl font-semibold text-[#0B2545] mb-1" data-id="element-337" data-mp="nqyy15lt87nc">Nursing Is Hard to Explain With Words.</p>
            <p className="text-xl font-semibold text-[#0A7D79] mb-5" data-id="element-338" data-mp="jr6mql517nea">
              Your Teaching Materials Shouldn&apos;t Be.
            </p>
            <div className="space-y-3 text-slate-700 leading-relaxed" data-id="element-339" data-mp="3n7dryw33hsp6">
              <p data-id="element-340" data-mp="3n988ly7c2yng">{imagine.join(' ')}</p>
              <p className="font-semibold text-[#0B2545]" data-id="element-341" data-mp="4txr3f8p3xgr">
                That&apos;s the advantage of a 100% visual training system.
              </p>
              <p data-id="element-342" data-mp="1efgntkjcel">
                <span className="font-semibold text-[#025B57]" data-id="element-343" data-mp="ut8uwvy1ur">NURSING INSTRUCTOR ATLAS</span> is built around
                illustrations, labeled diagrams, clinical sequences, numbered breakdowns, ❌/✅ comparisons,
                teaching cues, drills and quick checks.
              </p>
            </div>
          </div>

          <div className="bg-[#F3F7FA] border border-slate-200 rounded-2xl p-6" data-id="element-344" data-mp="1cf2zdmxl7c4m">
            <p className="text-sm font-bold text-[#025B57] uppercase tracking-wider mb-4" data-id="element-345" data-mp="1h62z0zy3c8at">
              Inside you’ll find:
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2.5" data-id="element-346" data-mp="1m44fre81nvj4">
              {insideItems.map(item => <li key={item} className="flex items-start gap-2 text-sm text-slate-700" data-id="element-347" data-mp="oip75g9922xk">
                  <CheckCircle2 size={16} className="text-[#0A7D79] shrink-0 mt-0.5" data-id="element-348" data-mp="thjt2r2ik7lw" />
                  <span data-id="element-349" data-mp="yfbqu1puany0">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} src={VISUAL_IMAGE} alt={VISUAL_IMAGE_ALT} loading="lazy" className="w-full max-w-2xl h-auto mx-auto mt-12 rounded-2xl border border-slate-200 shadow-lg shadow-[#0B2545]/10" data-id="element-350" data-mp="13g9akiqhzq1m" />

        <p className="text-center text-2xl md:text-4xl font-extrabold tracking-tight text-[#0B2545] mt-14" data-id="element-351" data-mp="3uf5cfkh3ccx7">
          <span className="text-[#0A7D79]" data-id="element-352" data-mp="3kmzm0f6hm3k4">100% VISUAL.</span> PRACTICAL. PROFESSIONAL.{' '}
          <span className="bg-[#0B2545] text-white px-2 box-decoration-clone" data-id="element-353" data-mp="3fnwodfsu6zm6">BUILT TO TEACH.</span>
        </p>
      </div>
    </section>;
}